// types/apiTypes.ts

import { AxiosError, AxiosRequestConfig } from 'axios';

export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';

/**
 * Base API Response Type
 * @template T - Type of the data payload
 */
export interface ApiResponse<T = any> {
  data: T;
  message?: string;
  statusCode?: number;
  success?: boolean;
  // Add any other standard fields your API returns
}

/**
 * Custom API Error Class
 */
export class ApiError extends Error {
  constructor(
    public message: string,
    public status?: number,
    public data?: any,
    public code?: string
  ) {
    super(message);
    this.name = 'ApiError';

    // Maintains proper stack trace for where our error was thrown
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
  }

  /**
   * Helper to check if error is an API error
   */
  static isApiError(error: unknown): error is ApiError {
    return error instanceof ApiError;
  }

  /**
   * Creates an ApiError from an AxiosError
   */
  static fromAxiosError(error: AxiosError<ApiResponse>): ApiError {
    if (error.response) {
      const { status, data } = error.response;
      return new ApiError(
        data?.message || error.message,
        status,
        data
        // data?.code
      );
    }
    return new ApiError(error.message, undefined, undefined, error.code);
  }
}

/**
 * Standard API Request Config
 * Extends AxiosRequestConfig with any custom options you need
 */
export interface ApiRequestConfig extends AxiosRequestConfig {
  // Add any custom request options here
  // Example:
  // skipLoading?: boolean; // To skip loading tracking for specific requests
}
